import { Box, Typography, Alert } from "@mui/material";

import { DropdownSimple } from "../../ui/dropdown-simple";
import { UNITS, UNITS_LIST } from "../../../constants/site-settings.constants";

export const StepUnits = ({
  changeUnitsHandler,
  units,
  detectedUnit,
  fileId,
  propertyFileId,
}) => {
  return (
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: "24px" }}>
      {fileId === propertyFileId ? null : (
        <Alert
          variant="outlined"
          severity={detectedUnit ? "success" : "warning"}
        >
          Units detected:{" "}
          <Typography component={"span"} fontSize={"0.875rem"} fontWeight={500}>
            {" "}
            {detectedUnit ? `${UNITS[detectedUnit]}.` : "not found"}
          </Typography>
        </Alert>
      )}

      <DropdownSimple
        key={"dropdown-units"}
        title={"Select units used in the drawing or change if incorrect"}
        list={UNITS_LIST}
        name={"units"}
        setValue={changeUnitsHandler}
        value={units}
        tooltip={""}
      />
    </Box>
  );
};
